<template>
  <div>
    <div class="row mb-3 options">
      <div class="col-lg-12 info">
        <el-button @click="step = !step" v-if="!step">
          <i class='bx bx-list-ul fz-18'></i>
        </el-button>

        <el-button @click="instruction = !instruction" v-if="!instruction">
          <i class='bx bxs-book-bookmark fz-18'></i>
        </el-button>
      </div>
    </div>

    <el-collapse-transition>
      <div class="row mb-3 step" v-show="step">
        <el-card class="box-card w-100">
          <h1 class="db-section-heading"><b>Bắt đầu NextShop chỉ với 7 bước</b></h1>
            <div class="step-inner row">
              <ul class="w-100">
                <li v-for="tutorial in dataStep"
                    :key="tutorial.index"
                    class="">
                  <div 
                    class="step-inner-left">
                    <div class="d-inline mr-3"><img :src="tutorial.image" alt="icon"></div>
                    <div class="step-des">
                      <a :href="tutorial.link" target="_blank">
                        <h2>{{ tutorial.title }}</h2>
                        <p>{{ tutorial.description }}</p>
                      </a>
                    </div>
                  </div>
                  <div class="step-inner-right">
                    <i v-if="tutorial.isCompleted" class="bx bxs-check-circle text-success fz-22"></i>
                    <i v-else class='bx bx-right-arrow-alt text-primary cursor fz-22'></i>
                  </div>
                </li> 
               
                <li class="step-sum">
                  <p class="d-inline mb-0">Bạn đã hoàn thành {{tutorialDone}}/7 bước</p>
                  <el-button class="hide-section" type="danger" plain @click="step = !step">
                    Ẩn danh sách
                  </el-button>
                </li>
              </ul>
            </div>
        </el-card>
      </div>
    </el-collapse-transition>

    <el-collapse-transition>
      <div class="row mb-3 instruction" v-show="instruction">
        <el-card class="box-card w-100">
          <div class="row">
            <div class="col-lg-4 instruction-inner">
              <h1 class="db-section-heading"><b>Hướng dẫn cơ bản</b></h1>
              <ul>
                <li v-for="item in guideBase" :key="item.index">
                    <a :href="item.link" target="_blank">{{ item.title }}</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-4 instruction-inner">
              <h1 class="db-section-heading"><b>Hướng dẫn nâng cao</b></h1>
              <ul>
                <li v-for="item in guideAdvanced" :key="item.index">
                    <a :href="item.link" target="_blank">{{ item.title }}</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-4">
              <div class="contact-info">
                <p>Nếu bạn cần hỗ trợ thêm, hãy liên hệ với chúng tôi:</p>
                <ul>
                  <li>Qua hotline:
                    <a href="tel:1900636956" class="text-primary">1900 636 956</a>
                  </li>
                  <li>Trang web hướng dẫn:
                    <a href="https://support.next360.vn" class="text-primary">
                      https://support.next360.vn
                    </a>
                  </li>
                </ul>
                <el-button class="hide-section" type="danger" plain @click="instruction = !instruction">
                  Bỏ qua hướng dẫn
                </el-button>
              </div>
            </div>
          </div>
        </el-card>      
      </div>
    </el-collapse-transition>

    <div class="mb-3">
      <el-card class="box-card w-100">
        <h1 class="db-section-heading db-section-heading-ext"><b>Kết quả kinh doanh trong ngày</b></h1>
        <div class="row">
          <div class="col-lg-4 mb-3">
            <div class="block-stat-wrapper">
              <div class="block-stat-inner">
                <div class="bs-inner-left">
                  <h1>Doanh thu</h1>
                  <p>{{ grossAmountTotal | formatCurrency }}</p>
                </div>
                <div class="bs-inner-right">
                  <span><img src="@/assets/images/db-doanh-thu.svg" alt="stat-icon"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-3">
            <dashboard-stat :statInfo="{ title: 'Đơn hàng hoàn thành', value: numberOrderSuccess }">
              <template #block-icon>
                <span><img src="@/assets/images/db-don-hoan-thanh.svg" alt="stat-icon"></span>
              </template>
            </dashboard-stat>
          </div>
          <div class="col-lg-4 mb-3">
            <dashboard-stat :statInfo="{ title: 'Khách hàng', value: customerCount }">
              <template #block-icon>
                <span><img src="@/assets/images/db-khach-hang.svg" alt="stat-icon"></span>
              </template>
            </dashboard-stat>
          </div>
        </div>
      </el-card>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <el-card class="box-card box-card-ext mb-3">
          <div slot="header" class="clearfix">
            <div class="row">
                <div class="col-lg-8 align-items-center">
                <h5 class="d-inline-block"><b>Doanh thu bán hàng</b></h5>
              </div>
              <div class="col-lg-4">
                <el-select
                  size="medium" class="w-100 pull-right"
                  v-model="valSelectDateRevenue"
                  @change="changeDateOrderReportV3()"
                  placeholder="Thời gian">
                  <el-option
                    v-for="item in optionDateTmp"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="stat-chart">
            <div class="text-center py-4" v-if="!orderChart">
              <span class="d-block py-3">
                <img src="@/assets/images/graph-blank.svg" alt="graph_blank" class="d-inline">
              </span>
              <p class="text-808890">Khi có dữ liệu bán hàng, biểu đồ doanh thu của bạn sẽ hiển thị tại đây</p>
              <el-button type="primary" plain>Bán hàng ngay</el-button>
            </div>
            <apexchart
              v-if="!loading"
              class="apex-charts"
              height="350"
              type="line"
              :options="orderChart.chartOptions" 
              :series="orderChart.series"
            />
          </div>
        </el-card>

        <el-card class="box-card box-card-ext mb-3">
          <div slot="header" class="clearfix">
            <div class="row">
                <div class="col-lg-8 align-items-center">
                <h5 class="d-inline-block"><b>Số đơn hàng thành công</b></h5>
              </div>
              <div class="col-lg-4">
                <el-select
                  size="medium" class="w-100 pull-right"
                  v-model="valSelectDateOrdersOk"
                  @change="changeDateOrderSuccReportV3()" 
                  placeholder="Thời gian">
                  <el-option
                    v-for="item in optionDateTmp"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="stat-chart">
            <div class="text-center py-4" v-if="!itemChart">
              <span class="d-block py-3">
                <img src="@/assets/images/graph-blank.svg" alt="graph_blank" class="d-inline">
              </span>
              <p class="text-808890">Khi có dữ liệu bán hàng, biểu đồ doanh thu của bạn sẽ hiển thị tại đây</p>
              <el-button type="primary" plain>Bán hàng ngay</el-button>
            </div>
            <apexchart
              v-if="!loading"
              class="apex-charts"
              height="350"
              type="area"
              dir="ltr"
              :series="itemChart.series"
              :options="itemChart.chartOptions"
            ></apexchart>
          </div>
        </el-card>
      </div>

      <div class="col-lg-4">
        <el-card class="stat-table-tab mb-3">
          <div slot="header" class="clearfix">
            <div class="row">
                <div class="col-lg-6 align-items-center">
                <h5 class="d-inline-block mt-2"><b>Sản phẩm bán chạy</b></h5>
              </div>
              <div class="col-lg-6">
                <el-select
                  size="medium" class="w-100 pull-right"
                  v-model="valSelectDateBestSell"
                  @change="changeDateItemReportV3()"  
                  placeholder="Thời gian">
                  <el-option
                    v-for="item in optionDateTmp"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <el-tabs v-model="activeTab" @tab-click="clickQuantityTab">
            <el-tab-pane label="THEO DOANH THU" name="revenueTab">
              <div class="tableShowItem">
                <el-table label="" :data="dataReportItem" v-if="dataReportItem.length > 0">
                  <el-table-column
                    prop="itemName"
                    label="Tên sản phẩm">
                    <template slot-scope="scope">
                      <span @click="$router.push({ path: `/items/items-detail/${scope.row.itemId}` })" class="itemName">{{ scope.row.itemName }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="totalAmount"
                    label="Doanh thu (đ)"
                    align="right">
                    <template slot-scope="scope">
                      <span @click="$router.push({ path: `/items/items-detail/${scope.row.itemId}` })" class="itemName">{{ scope.row.netRevenue }}</span>
                    </template>
                  </el-table-column>
                </el-table>

                <div class="boxEmpty" v-else>
                    <div class="imgEmpty"><img src="@/assets/images/box-nothing.svg"></div>
                    <div class="textEmpty">
                      Chưa có sản phẩm bán chạy. Khi bắt đầu bán hàng, sản phẩm của bạn sẽ hiện thị tại đây.
                    </div>
                </div>

              </div>
            </el-tab-pane>
            
            <el-tab-pane label="THEO SỐ LƯỢNG" name="quantityTab">
              <div class="tableShowItem">
                  <el-table :data="dataReportItem" v-if="dataReportItem.length > 0">
                    <el-table-column
                      prop="itemName"
                      label="Tên sản phẩm">
                      <template slot-scope="scope">
                        <span @click="$router.push({ path: `/items/items-detail/${scope.row.itemId}` })" class="itemName">{{ scope.row.itemName }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="quantity"
                      label="Số lượng"
                      align="right">
                      <template slot-scope="scope">
                        <span @click="$router.push({ path: `/items/items-detail/${scope.row.itemId}` })" class="itemName">{{ scope.row.quantity }}</span>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div class="boxEmpty" v-else>
                    <div class="imgEmpty"><img src="@/assets/images/box-nothing.svg"></div>
                    <div class="textEmpty">
                      Chưa có sản phẩm bán chạy. Khi bắt đầu bán hàng, sản phẩm của bạn sẽ hiện thị tại đây.
                    </div>
                </div>

              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <div class="banner-app">
          <h1 class="fz-14 mb-3">Tải về ứng dụng NextShop tại</h1>
          <div class="links">
            <a :href="playStoreLink" class="d-block mb-2" target="_blank">
              <span class="d-inline-block">
                <img src="@/assets/images/play-store.svg" alt="play-store" class="d-inline">
              </span>
            </a>

            <a :href="appStoreLink" class="d-block mb-2">
              <span class="">
                <img src="@/assets/images/app-store.svg" alt="play-store" class="d-inline" target="_blank">
              </span>
            </a>

            <div class="d-inline-block dl-section-wrap">
              <span class="dl-section-img">
                <img src="@/assets/images/db-banner-img.svg" alt="banner-img">
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-loading" v-if="loading">
      <div class="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import VueCookies from "vue-cookies";
import DashboardStat from "@/components/dashboard-stat.vue"
import { ReportService } from '@/services/nextshop/report.service'
import { OtherService } from "@/services/other.service"

export default {
  components: {
    DashboardStat,
  },
  data() {
    return {
      loading: false,
      step: false,
      instruction: false,
     
      appId: process.env.VUE_APP_ID,
      LID: VueCookies.get("LID"),

      customerCount: 0,     
      grossAmountTotal: 0,
      numberOrderSuccess: 0,

      dataStep: [
        { 
          title: "Thiết lập cửa hàng",
          image: require("@/assets/images/store.svg"), 
          description: "Cài đặt các thông tin cho cửa hàng của bạn",
          link: "/setting/merchant-info"
        },
        { 
          title: "Thêm sản phẩm",
          image: require("@/assets/images/add-box.svg"),
          description: "Tạo mới và quản lý tồn kho theo từng sản phẩm",
          link: "/items/items-add"
        },
        { 
          title: "Tạo đơn bán hàng",
          image: require("@/assets/images/cashier-machine.svg"),
          description: "Tạo đơn và quản lý đơn hàng của bạn",
          link: "/pos"
        },
        { 
          title: "Thêm khách hàng",
          image: require("@/assets/images/add-staff.svg"),
          description: "Lưu lại liên lạc để thanh toán với khoản nợ",
          link: "/customer-list/customer-add"
        },
        { 
          title: "Thêm nhà cung cấp",
          image: require("@/assets/images/add-inventory.svg"),
          description: "Lưu lại liên lạc và để chọn nguồn nhập kho",
          link: "/supplier-list/supplier-add"
        },
        { 
          title: "Thêm nhân viên",
          image: require("@/assets/images/add-staff.svg"),
          description: "Phân quyền giúp bảo mật và làm việc hiệu quả",
          link: "/employee-and-role/employee-create"
        },
        { 
          title: "Tích hợp quẹt thẻ MPOS",
          image: require("@/assets/images/mpos-integrate.svg"),
          description: "Thêm phương thức thanh toán tiện lợi hơn",
          link: "/setting/mpos-connect"
        }
      ],
      guideBase: [
        { 
          title: "Cập nhật thông tin cửa hàng",
          link: "https://support.next360.vn/huong-dan-cap-nhat-thong-tin-cua-hang"
        },
        { 
          title: "Thêm mới sản phẩm",
          link: "https://support.next360.vn/huong-dan-them-moi-san-pham"
        },
        { 
          title: "Quản lý danh mục sản phẩm",
          link: "https://support.next360.vn/quan-ly-danh-muc-san-pham"
        },
        { 
          title: "Hướng dẫn bán hàng",
          link: "https://support.next360.vn/huong-dan-ban-hang-danh-sach-don-hang"
        }
      ], 
      guideAdvanced: [
        { 
          title: "Quản lý đơn vị tính, thương hiệu",
          link: "https://support.next360.vn/quan-ly-don-vi-tinh-thuong-hieu-bao-hanh"
        },
        { 
          title: "Kết nối và cấu hình bán hàng MPOS",
          link: "https://support.next360.vn/ket-noi-va-cau-hinh-ban-hang-mpos"
        },
        { 
          title: "Chuyển đổi dữ liệu từ NextShop 1.0",
          link: "https://support.next360.vn/chuyen-doi-du-lieu-tai-khoan"
        }
      ], 
      orderChart: {
        series: [
          {
            name: "Doanh thu",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          colors: ["#556ee6", "#34c38f"],
          markers: {
            size: [5],
          },
          xaxis: {
            labels: {
              formatter(value) {
                return (
                  String(value).substring(6, 8) +
                  "/" +
                  String(value).substring(4, 6)
                );
              },
            },
            categories: [],
          },
          yaxis: {
            labels: {
              formatter(value) {
                return value.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                });
              },
            },
            title: {
              text: "đ (đồng)",
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          tooltip: {
            y: {
              formatter: function(value) {
                return value.toLocaleString("vi", {
                  style: "currency",
                  currency: "VND",
                });
              },
            },
          },
        },
      },

      itemChart: {
        series: [
          {
            name: "Số đơn hàng",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          colors: ["#556ee6", "#34c38f"],
          markers: {
            size: [5],
          },
          xaxis: {
            categories: [],
            labels: {
              formatter(value) {
                return (
                  String(value).substring(6, 8) +
                  "/" +
                  String(value).substring(4, 6)
                );
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          }
        },
      },
     
      activeTab: "revenueTab",
      itemSortTypeTab: "netRevenueDesc",

      dataTutorial: {},
      tutorialDone: 0,

      playStoreLink: "https://play.google.com/store/apps/details?id=com.nextpay.next360",
      appStoreLink: "https://apps.apple.com/vn/app/next360/id1557828825",
      
      dateRange: {
        startDate:  moment(moment().subtract(7, "days")._d).format("YYYYMMDD"),
        endDate: moment(moment().subtract(1, "days")._d).format("YYYYMMDD")
      },
      dataReportItem: [],
      valSelectDateRevenue: '7_ngay_truoc',
      valSelectDateOrdersOk: '7_ngay_truoc',
      valSelectDateBestSell: '7_ngay_truoc',
      optionDateTmp:[
        {value: 'hom_nay', label: 'Hôm nay'},
        {value: 'hom_qua', label: 'Hôm qua'},
        {value: '7_ngay_truoc', label: '7 ngày trước'},
        {value: '30_ngay_truoc', label: '30 ngày trước'},
        {value: 'tuan_truoc', label: 'Tuần trước'},
        {value: 'thang_truoc', label: 'Tháng trước'}
      ],
      arrDateRange: {
        'hom_nay': {
          startDate: moment(moment()._d).format("YYYYMMDD"),
          endDate:moment(moment()._d).format("YYYYMMDD")
        },
        'hom_qua': {
          startDate: moment(moment().subtract(1, "days")._d).format("YYYYMMDD"),
          endDate: moment(moment().subtract(1, "days")._d).format("YYYYMMDD")
        },
        '7_ngay_truoc': {
          startDate:  moment(moment().subtract(7, "days")._d).format("YYYYMMDD"),
          endDate: moment(moment().subtract(1, "days")._d).format("YYYYMMDD")
        },
        '30_ngay_truoc': {
          startDate:  moment(moment().subtract(30, "days")._d).format("YYYYMMDD"),
          endDate: moment(moment().subtract(1, "days")._d).format("YYYYMMDD")
        },
        'tuan_truoc': {
          startDate: moment(moment().subtract(1, "week").startOf("week")._d).format("YYYYMMDD"),
          endDate: moment(moment().subtract(1, "week").endOf("week")._d).format("YYYYMMDD")
        },
        'thang_truoc': {
          startDate: moment(moment().subtract(1, "month").startOf("month")._d).format("YYYYMMDD"),
          endDate: moment(moment().subtract(1, "month").endOf("month")._d).format("YYYYMMDD")
        }
      },
      fieldList: {
        addedAmount: "SUM",
        addedFee: "SUM",
        discount: "SUM",
        finalAmount: "SUM",
        grossAmount: "SUM",
        netRevenue: "SUM",
        numberOrders: "SUM",
        tax: "SUM",
        totalAmount: "SUM",
        totalImportPrice : "SUM",
        netAmount: "SUM",
        numberItems: "SUM"
      },
      isRealtime: true
    };
  },
  async created() {
    await this.updateValues()
  },
  methods: {
    async updateValues(){
      this.loading = true
      this.getTutorial();
      await this.totalReportV3()
      await this.orderReportV3()
      await this.orderSuccReportV3()
      await this.itemReportV3()
      await this.getNumCustomers()
      this.loading = false
    },
    async getTutorial() {
      try {
        const response = await OtherService.getTutorial()
        if (response.success) {
          this.dataTutorial = response.data.data.steps
          this.dataStep.map((el, index) => {
            response.data.data.steps.map((e, id) => {
              if (index == id) {
                this.dataStep[index] = {...e, ... this.dataStep[index]}
              }
            })
          })
          const itemDone = this.dataTutorial.filter(e => e.isCompleted)
          this.tutorialDone = itemDone.length
        }
        
      } catch (error) {
        console.log(error)
      }
    },

    async getNumCustomers() {
      try {
        const params = {
          "dimensionTime": "DAY",
          "locationId": this.LID,
          "orderStatus": "SUCCESS",
          "fromDate": moment(moment()._d).format("YYYYMMDD"),
          "toDate": moment(moment()._d).format("YYYYMMDD"),
          "isRealtime": true
        }
        const response = await ReportService.totalCustomerReportV3(params)
        if(response.success){
          this.customerCount = response.data[0].totalRecord
        }
      } catch (error) {
        this.loading = false;
      }
    },

    async totalReportV3() {
      try {
        const params = {
          "dimensionTime": "DAY",
          "locationId": this.LID,
          "orderStatus": "SUCCESS",
          "fromDate": moment(moment()._d).format("YYYYMMDD"),
          "toDate": moment(moment()._d).format("YYYYMMDD"),
          "isRealtime": true
        }
        const response = await ReportService.totalOrderReportV3(params)
        if(response.success){
          this.grossAmountTotal = this.divisionThousand(response.data[0].grossAmount)
          this.numberOrderSuccess = response.data[0].numberOrders
        }
      } catch (error) {
        this.loading = false;
      }
    },

    async changeDateOrderReportV3(){
      this.loading = true
      this.dateRange = this.arrDateRange[`${this.valSelectDateRevenue}`]
      await this.orderReportV3()
      this.loading = false
    },
    async orderReportV3(){
      this.checkRangDate()
      this.orderChart.series[0].data = []
      this.orderChart.chartOptions.xaxis.categories = []
      const getParams = {
        "dimensionTime": "DAY",
        "orderStatus": "SUCCESS",
        "locationId": this.LID,
        "fromDate": this.dateRange.startDate,
        "toDate": this.dateRange.endDate,
        "sort": "timeIdDesc",
        "isRealtime": this.isRealtime,
        "page": 1,
        "perPage": 50000
      }
      const response = await ReportService.orderReportV3(getParams)
      if(response.success){
        const reverseData = [...response.data].reverse()
        reverseData.map((item)=>{
          this.orderChart.series[0].data.push(this.divisionThousand(item.grossAmount))
          this.orderChart.chartOptions.xaxis.categories.push(item.timeId)
        })
      }
    },
    
    async changeDateOrderSuccReportV3(){
      this.loading = true
      this.dateRange = this.arrDateRange[`${this.valSelectDateOrdersOk}`]
      await this.orderSuccReportV3()
      this.loading = false
    },
    async orderSuccReportV3(){
      this.checkRangDate()
      this.itemChart.series[0].data = []
      this.itemChart.chartOptions.xaxis.categories = []
      const getParams = {
        "dimensionTime": "DAY",
        "orderStatus": "SUCCESS",
        "locationId": this.LID,
        "fromDate": this.dateRange.startDate,
        "toDate": this.dateRange.endDate,
        "sort": "timeIdDesc",
        "isRealtime": this.isRealtime,
        "page": 1,
        "perPage": 50000
      }
      const response = await ReportService.orderReportV3(getParams)
      if(response.success){
        const reverseData = [...response.data].reverse()
        reverseData.map((item)=>{
          this.itemChart.series[0].data.push(item.numberOrders)
          this.itemChart.chartOptions.xaxis.categories.push(item.timeId)
        })
      }
    },
   
    changeDateItemReportV3(){
      this.dateRange = this.arrDateRange[`${this.valSelectDateBestSell}`]
      this.itemReportV3()
    },
    async itemReportV3(){
      this.checkRangDate()
      this.dataReportItem = []
      const getParams = {
        "dimensionTime": "DAY",
        "locationId": this.LID,
        "fromDate": this.dateRange.startDate,
        "toDate": this.dateRange.endDate,
        "sort": this.itemSortTypeTab,
        "isRealtime": this.isRealtime,
        "page": 1,
        "perPage": 30000
      }
      const response = await ReportService.itemReportV3(getParams)
      if(response.success){
        response.data.map((item)=>{
          item.netRevenue = this.divisionThousand(item.netRevenue)
          item.discount = this.divisionThousand(item.discount)
          item.tax = this.divisionThousand(item.tax)

          const tmp = {
            itemId: item.itemId,
            sku: item.sku,
            itemName: item.itemName,
            quantity: item.quantity,
            numberOrders: item.numberOrders,
            netRevenue: this.formatMoneyNotUnitExt(item.netRevenue)
          }
          this.dataReportItem.push(tmp)
        })
      }
    },
    checkRangDate(){
      const endDate = this.dateRange.endDate
      const currentDate = moment(new Date()).format('YYYYMMDD')
      if(endDate != currentDate){
        this.isRealtime = false
      }else{
        this.isRealtime = true
      }
    },
    async clickQuantityTab(){
      if(this.activeTab == 'quantityTab'){
        this.itemSortTypeTab = 'quantityDesc'
      }else{
        this.itemSortTypeTab = 'netRevenueDesc'
      }
      await this.itemReportV3()
    }
  }
}
</script>
<style scoped lang="scss">
.block-stat-wrapper {
  padding: 0 10px;
  .block-stat-inner {
    height: 82px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px 20px;
    border-radius: 8px;

    h1 {
      font-size: 14px;
      font-weight: 400;
      line-height: 22.4px;
    }

    p {
      font-size: 20px;
      font-weight: 600;
      line-height: 30px;
      margin-bottom: 0;
    }

    .bs-inner-right {
      span {
        width: 36px;
        height: 36px;
        display: block;

        img {
          display: inline-block;
        }
      }
    }
  }
}

.block-stat-wrapper:first-child {
  padding-left: 0;
}

.block-stat-wrapper:last-child {
  padding-right: 0;
}

.text-808890 {
  color: #808890;
}

.options {
  justify-content: space-between;
  align-items: center;
}

.el-card__header {
  border-bottom: none;

  div {
    h5 {
      margin-bottom: 0;
    }
  }
}

.banner-app {
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 18px 20px;
  overflow: hidden;

  h1 {
    margin-bottom: 14px;
  }

  .dl-section-wrap {
    position: absolute;
    top: 0;
    right: 0;
  }

  .dl-section-img {
    position: relative;
    display: inline-block;
    z-index: 2;

    &::after {
      display: inline;
      position: absolute;
      content: "";
      top: 24px;
      left: 0;
      width: 246px;
      height: 246px;
      background: url("../../assets/images/bg-gradient.svg") no-repeat;
      z-index: -1;
    }
  }
}

::v-deep .stat-table-tab {
  .el-card__body {
    padding-top: 0;
  }
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
}

::v-deep .el-table__header {
  thead {
    tr {
      th {
        .cell {
          padding: 0;
        }
      }
    }
  }
}

::v-deep .el-tabs__content {
  .tableShowItem {
    overflow-y: auto;
  }
}

::v-deep .el-table__row {
  td {
    .cell {
      padding-left: 0;
    }
  }
}

::v-deep .info {
  display: flex;
  justify-content: flex-end;

  button {
    padding: 12px;
    text-align: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
  }
}

.step,
.instruction {
  padding-left: 12px;
  padding-right: 12px;
}

.db-section-heading {
  font-size: 16px;
  line-height: 24px;
  padding-bottom: 15px;
  margin-bottom: 0;
  border-bottom: 1px solid #ddd;
}

button.hide-section {
  background: none;
  border: 1px solid #f56c6c;

  &:hover {
    color: #fff;
    background: #f56c6c;
  }

  &:focus {
    color: #f56c6c;
    background: #fff;
  }
}

.step-inner {
  ul {
    column-count: 2;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 12px;

      .step-inner-left {
        display: flex;
        justify-content: flex-start;
      }

      &:not(:first-child) {
        border-top: 1px solid #dddddd;
      }
    }

    li.step-sum {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        font-size: 16px;
        color: #808890;
        line-height: 24px;
      }
    }
  }
  .step-des {
    h2 {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 0;
    }

    p {
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 0;
      color: #808890;
    }
  }
}

.instruction-inner {
  ul {
    padding: 15px 0 0 20px;

    li {
      margin-bottom: 15px;
      font-size: 16px;
      color: #3e69f6;
      list-style-type: disc;
    }
  }
}

.contact-info {
  font-size: 16px;
  line-height: 24px;
  padding: 25px 30px 20px;
  border: 1px solid #dddddd;
  border-radius: 8px;

  ul {
    padding: 0 20px;
    margin-bottom: 20px;

    li {
      list-style-type: disc;
    }
  }
}
.db-section-heading-ext {
  border-bottom: 0;
}
.step-inner ul li:nth-child(5) {
  border-top: none !important;
}
.block-stat-wrapper {
  border: 1px solid #ddd;
  border-radius: 10px;
}
::v-deep .box-card-ext .el-card__header {
  border-bottom: 0;
}
.dashboard-datepicker-v2 {
  position: absolute;
  z-index: 99999;
  right: 0;
}
.apex-charts {
  display: inline-block;
  width: 100%;
}
::v-deep .tableShowItem tr:hover td{
  cursor: pointer;
  font-weight: bold;
}
.boxEmpty{
  text-align: center;
  padding: 80px 0 70px;
}
.textEmpty{
  color: #808890;
  margin-top: 20px;
}
</style>
